export default "/images/76480e205d35a21d9a28bf18a66eaf00.avif";